import { StyleSystemProps } from '@withjoy/joykit';
import { PRODUCT_GRID_BREAKPOINTS } from '../../../../Catalog.constants';

export const productOffersGridStyles: StyleSystemProps = {
  marginTop: 8,
  display: 'grid',
  gridColumnGap: {
    _: 3,
    sm2: 10
  },
  gridRowGap: {
    _: 5,
    sm2: 10
  },
  paddingX: {
    _: 3,
    sm2: 7
  },
  gridTemplateColumns: {
    [PRODUCT_GRID_BREAKPOINTS[0]]: 'repeat(2, 1fr)',
    [PRODUCT_GRID_BREAKPOINTS[1]]: 'repeat(3, minmax(0, 1fr))',
    // NOTE: Commenting out until discussing with merch about 4 columns
    [PRODUCT_GRID_BREAKPOINTS[2]]: 'repeat(4, minmax(0, 1fr))',
    [PRODUCT_GRID_BREAKPOINTS[3]]: 'repeat(5, minmax(0, 1fr))',
    [PRODUCT_GRID_BREAKPOINTS[4]]: 'repeat(6, minmax(0, 1fr))'
  }
};
